import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  useIntl,
} from 'react-intl';
import Button from 'components/utils/button';
import { ID } from 'utils/constants';
import { getSearchParam } from 'utils/params';

const intlMessages = defineMessages({
  summary: {
    id: 'button.summary.aria',
    description: 'Aria label for the summary button',
    defaultMessage: 'Summary',
  },
});

const propTypes = { openModal: PropTypes.func };

const defaultProps = { openModal: () => {} };

const Summary = ({ openModal }) => {
  const intl = useIntl();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Try to get meetingId from query param first, then fallback to path param logic if applicable
    // But since useParams is a hook, we can't conditionally call it.
    // If we are mostly query param based in non-router mode, getSearchParam works.
    // Use window.location as fallback or regex if useParams is not available/reliable in this context.
    let meetingId = getSearchParam('meetingId');

    if (!meetingId) {
       // Fallback: try to extract from path if matches /presentation/:id
       const match = window.location.pathname.match(/\/presentation\/([^/]+)/);
       if (match && match[1]) {
           meetingId = match[1];
       }
       // Also try standard recordId format from path end if it matches BBB pattern
       // This matches the Router /:recordId pattern roughly if we are at root of basename
       // But safer to just look for the ID pattern
       const parts = window.location.pathname.split('/');
       const potentialId = parts[parts.length - 1];
        if (potentialId && potentialId.match(/^[a-z0-9]{40}-[0-9]{13}$/)) {
            meetingId = potentialId;
        }
    }

    if (!meetingId) return;

    const url = `/presentation/${meetingId}-summary/summary.md`;

    fetch(url, { method: 'HEAD' })
      .then(response => {
        if (response.ok) {
          setVisible(true);
        }
      })
      .catch(() => {
        // Ignore errors, button just won't show
      });
  }, []);

  if (!visible) return null;

  return (
    <Button
      aria={intl.formatMessage(intlMessages.summary)}
      handleOnClick={() => openModal(ID.SUMMARY)}
      label={intl.formatMessage(intlMessages.summary)}
    />
  );
};

Summary.propTypes = propTypes;
Summary.defaultProps = defaultProps;

export default Summary;
